module.exports = __webpack_public_path__ + "static/oh_structure-3032c3475c0e2f4340b93e94149bef1e.png";